import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { useCreateGroupMutation } from "../../../api/managementApi";

export default function CreateGroupModal({ open, onClose, onCreated }) {
  const { t } = useScriptMode();
  const [groupName, setGroupName] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [createGroup, { isLoading }] = useCreateGroupMutation();

  useEffect(() => {
    if (!open) {
      setGroupName("");
      setDescription("");
      setError("");
    }
  }, [open]);

  const trimmed = groupName.trim();
  const canSubmit = trimmed.length >= 2 && trimmed.length <= 25 && !isLoading;

  const handleSubmit = async () => {
    if (!canSubmit) return;
    try {
      const res = await createGroup({
        groupName: trimmed,
        description: description.trim(),
      }).unwrap();
      const id = res?.data?.group?.id;
      onCreated && onCreated(id);
      onClose && onClose();
    } catch (err) {
      const msg = err?.message || err?.data?.message || t("manage_create_error");
      setError(msg);
    }
  };

  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 600 }}>{t("manage_create_modal_title")}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label={t("manage_create_name_label")}
          value={groupName}
          onChange={(e) => {
            setGroupName(e.target.value);
            setError("");
          }}
          margin="normal"
          inputProps={{ maxLength: 25 }}
        />
        <TextField
          fullWidth
          label={t("manage_create_description_label")}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          margin="normal"
          multiline
          minRows={2}
        />
        {error ? (
          <Typography color="error" variant="body2" mt={1}>
            {error}
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("manage_create_cancel")}</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={!canSubmit}>
          {t("manage_create_submit")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
